import React from 'react';
// LevelEditor imports
import PrefabCategory from './category';
import { RecentsCategoryString } from '../../../../../../../GameKit/shared';
// Library imports
import LibraryManager from '../../../../../../../Game/Base/Library/LibraryManager';

class PrefabCategories extends React.Component {
    getCategoriesList = () => {
        const list = [];
        const library = LibraryManager.prefabs;

        // Loop through categories
        for(let i = 0; i < library._categories.length; ++i) {
            const { title } = library._categories[i];
            list.push(
                <PrefabCategory 
                    key={i}
                    title={title}
                />
            );
        }

        return list;
    }

    render = () => {
        const categoriesList = this.getCategoriesList();

        return (
            <div className="prefab-categories-container">
                <div className="prefab-categories">
                    {
                        categoriesList
                    }
                    <PrefabCategory 
                        key={categoriesList.length}
                        title={RecentsCategoryString}
                    />
                </div>
            </div>
        );
    }
}

export default PrefabCategories;
                